// Main energy system exports
export * from './types';
export * from './circadian';
export * from './blocks';
export * from './user-settings';
export * from './forecast';
export * from './adaptive-settings';

// Enhanced visualization exports with async support
export { 
  getEnergyForecast,
  getEnergyForecastSync,
  createEnergyVisualization,
  getForecastForDay,
  getCurrentEnergyZone,
  getEnergyZonesVisualization,
  createChronotypeComparison,
  generateEnergyInsights,
  createAdvancedVisualization
} from './visualization';

// Utils exports (excluding duplicates)
export {
  convertEnergyPreference,
  convertLegacyToEnergyZone,
  getCurrentEnergy,
  getEnergyChartData,
  calculateAverageEnergy,
  findPeakEnergyTimes,
  formatEnergyLevel,
  parseChronotype,
  isInSleepWindow,
  getChronotypeAwareEnergy,
  calculateEnergyTrend,
  energyGradients,
  getEnergyGradient
} from './utils';

// Legacy compatibility functions
import { getEnergyForecastSync } from './visualization';
import { parseTimeToHours } from './user-settings';

// Mock wearable data for testing
export const mockWearableData = {
  sleepScore: 85,
  hrvScore: 45,
  readinessScore: 78,
  recoveryScore: 82
};

// Legacy energy level type
export type LegacyEnergyLevelType = 'high' | 'good' | 'medium' | 'moderate' | 'low';

// Backward compatibility wrapper
export function getLegacyEnergyForecast(
  wakeTimeHour: number = 7,
  sleepDuration: number = 8,
  useWearableData: boolean = false
): number[] {
  const baselineInput = {
    wakeTimeHour,
    sleepDuration,
    useShiftedCurve: true
  };
  
  const wearableInput = useWearableData ? mockWearableData : undefined;
  return getEnergyForecastSync(baselineInput, wearableInput);
}

// Convert energy zone to legacy format
export function convertEnergyZoneToLegacy(energyLevel: number): any {
  if (energyLevel >= 80) return { type: 'power', label: 'Power Zone' };
  if (energyLevel >= 60) return { type: 'focus', label: 'Focus Zone' };
  return { type: 'drift', label: 'Drift Zone' };
}

// Legacy alias for backward compatibility
export const fetchEnergyForecast = getEnergyForecastSync;

// Re-export enhanced energy service
export { MemoizedEnergyService } from './memoized-energy-service';
